import React from "react";

function ButtonImg({ onClick, imageUrl, className, active }){
    if (active === false) {
        return (
            <button className={className} disabled>
                <img src={imageUrl} alt="flag"></img>
            </button>
        );
    } else {
        return (
            <button className={className} onClick={onClick}>
                <img className={className} src={imageUrl} alt="flag"></img>
            </button>
        );
    }
};

export default ButtonImg;